import React from 'react'
import {Button} from 'reactstrap'
import {getUserPermissions} from '../../../utils/userPermissions'

export default function multiLogsButtons() {
  let weldsIdxs = filterIdxbyId(this.state.welds, this.state.selectedIndexes)
  if (weldsIdxs.length > 0) {
    let selectedWelds = weldsIdxs.map(idx => this.state.welds[idx])
    let btnArray = []

    if (getUserPermissions('wl_welds.welds.block')) {
      btnArray.push(
        <Button id='block_import_multi_btn' key='block_import_multi_btn' onClick={() => {
          const toBlock = selectedWelds.filter(w => !w.blocked_for_import)
          Promise.all(toBlock.map(weld => this.props.toggleBlockWeld({ variables: { id: weld.id } }))).then(results => {
            let newWelds = [...this.state.welds]
            results.forEach(({ data: { toggleBlockWeld } }) => {
              if (toggleBlockWeld.weld) {
                const idx = newWelds.findIndex(w => w.id === toggleBlockWeld.weld.id)
                if (idx !== -1) newWelds[idx] = { ...newWelds[idx], blocked_for_import: true }
              }
            })
            this.setState({ welds: newWelds })
          })
        }} style={{float: 'left'}}><i className="fa fa-lock" style={{color: '#c0392b'}} /> Block for import
        </Button>
      )
      btnArray.push(
        <Button id='unblock_import_multi_btn' key='unblock_import_multi_btn' onClick={() => {
          const toUnblock = selectedWelds.filter(w => w.blocked_for_import)
          Promise.all(toUnblock.map(weld => this.props.toggleBlockWeld({ variables: { id: weld.id } }))).then(results => {
            let newWelds = [...this.state.welds]
            results.forEach(({ data: { toggleBlockWeld } }) => {
              if (toggleBlockWeld.weld) {
                const idx = newWelds.findIndex(w => w.id === toggleBlockWeld.weld.id)
                if (idx !== -1) newWelds[idx] = { ...newWelds[idx], blocked_for_import: false }
              }
            })
            this.setState({ welds: newWelds })
          })
        }} style={{float: 'left'}}><i className="fa fa-unlock" style={{color: '#27ae60'}} /> Unblock for import
        </Button>
      )
    }

    btnArray.push(
      <Button id='assign_inspection_category_multi_btn' key='assign_inspection_category_multi_btn' onClick={() => {
        this.setState({inspectionCategoryModal: true, LogModalWeldIdx: selectedWelds})
      }} style={{float: 'left'}}>Assign Inspection Category
      </Button>
    )
    btnArray.push(
      <Button id='assign_wps_multi_btn' key='assign_wps_multi_btn' onClick={() => {
        this.setState({wpsModal: true, LogModalWeldIdx: selectedWelds})
      }} style={{float: 'left'}}>Assign WPS
      </Button>
    )
    if (getUserPermissions('wl_welds.welding_logs.create')) {
      btnArray.push(
        <Button id='add_welding_multi_btn' key='add_welding_multi_btn' onClick={() => {
          this.setState({weldingModal: true, LogModalWeldIdx: weldsIdxs})
        }} style={{float: 'left'}}>Add Welding
        </Button>
      )
    }
    if (getUserPermissions('wl_welds.inspection_logs.create') && this.state.welds[weldsIdxs[0]].inspection_category) {
      btnArray.push(
        <Button id='add_inspection_multi_btn' key='add_inspection_multi_btn' onClick={() => {
          this.setState({inspectionModal: true, LogModalWeldIdx: weldsIdxs})
        }} style={{float: 'left'}}>Add Inspection
        </Button>
      )
    }
    return btnArray
  } else {
    return null
  }
}

function filterIdxbyId(welds, indexes) {
  return indexes.filter(idx => welds[idx] && welds[idx].id)
}



// WEBPACK FOOTER //
// ./src/components/Welds/helpers/multiLogsButtons.js